import dayjs from 'dayjs';

import Calendar from '@/modules/calendar/components/data-calendar/calendar';
import { useWidgetParams, useWidgetNavigate } from '@/core/widgets/export';

export default function DataCalendarPage() {
  const { date, view } = useWidgetParams();

  const navigate = useWidgetNavigate();

  return (
    <Calendar
      key={'calendar-' + date + '-' + view}
      date={date || 'today'}
      view={(view || 'daily') as 'daily' | 'weekly'}
      onNavigate={({ date, view }) => {
        console.log('Navigating', date, view);
        navigate(`/${view}/${date}`);
      }}
      onEventSelect={({ date, event }) => {
        const currentView = view || 'daily';
        const currentDate = date || 'today';
        if (event.auction) {
          navigate(
            `/auction-event/${dayjs(event.date).valueOf()}/${
              event.auction.auctionProducts[0].auctionHolder.id
            }?view=${currentView}&date=${currentDate}`,
          );
        } else {
          navigate(`/event/${event.id}?view=${currentView}&date=${currentDate}`);
        }
      }}
    />
  );
}
